import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import {
  defValueFazendas,
  IFazendas,
} from "../../types/api/comercial/pesquisar-fazenda";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";

export default function SelectFazenda({
  value,
  codigo,
  tipo,
  obrigatorio = false,
  onChange,
  disabled = false,
}: SelectSimpleApiQueryProps) {
  const [openModal, setOpenModal] = useState(false);

  const handleClose = () => setOpenModal(false);

  const inputLabel = value ? `${value.apelido} - ${value.nome}` : "";

  return (
    <>
      <TextField
        label={`Fazenda${obrigatorio ? "*" : ""}`}
        variant="outlined"
        fullWidth
        onClick={() => setOpenModal(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setOpenModal(true);
          }
        }}
        slotProps={{
          input: { readOnly: true }
        }}
        value={inputLabel}
        disabled={disabled}
      />

      {openModal && (
        <Dialog fullWidth maxWidth="sm" open={openModal} onClose={handleClose}>
          <DialogContentSelectGeneric
            {...{ handleClose }}
            title="Selecionar fazenda"
            queryPath="/pesquisar-fazendas"
            defaultValue={value || defValueFazendas}
            extraParams={{ codigo_publico: codigo, tipo_publico: tipo }}
            getItemKey={(item) => item.id}
            getItemLabel={(item) => `${item.apelido} - ${item.nome}`}
            onChange={(value) => {
              onChange(value as IFazendas);
              handleClose();
            }}
          />
        </Dialog>
      )}
    </>
  );
}

interface SelectSimpleApiQueryProps {
  value: IFazendas;
  codigo?: number;
  tipo?: string;
  onChange: (arg: IFazendas | null) => void;
  obrigatorio?: boolean;
  disabled?: boolean;
}
